module.exports = __webpack_public_path__ + "static/media/python_icon.e9722bca.png";